// extracted by mini-css-extract-plugin
export var bottomRightDock = "_50-0";